var _ellipse, _path, _rect, _rect2, _rect3, _rect4, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 142,
    viewBox: "0 0 199 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 104.7,
    cy: 137.943,
    rx: 54.9796,
    ry: 3.94276,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M198.265 72.52C197.564 110.546 141.182 79.5304 106.5 88C79.2026 94.6663 78.0001 111.098 40.5 112.5C2.99986 113.902 1.15889 77.0916 0.720856 55.9906C0.720856 27.1301 19.8033 -8.6358 49.4178 1.87822C79.0323 12.3922 131.721 44.8949 160.999 30C177.502 21.6058 198.965 34.4943 198.265 72.52Z",
    fill: "#FE385C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60.5957,
    y: 18.875,
    width: 88.25,
    height: 38.25,
    rx: 4.125,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5957,
    y: 18.875,
    width: 88.25,
    height: 38.25,
    rx: 4.125,
    stroke: "#FF395D",
    strokeWidth: 1.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5957,
    y: 66.875,
    width: 88.25,
    height: 38.25,
    rx: 4.125,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5957,
    y: 66.875,
    width: 88.25,
    height: 38.25,
    rx: 4.125,
    stroke: "#FF395D",
    strokeWidth: 1.75
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.06659,
    cy: 3.06659,
    r: 2.84755,
    transform: "matrix(-1 0 0 1 116.314 75)",
    fill: "#C40C2E",
    stroke: "white",
    strokeWidth: 0.438084
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.06659,
    cy: 3.06659,
    r: 2.84755,
    transform: "matrix(-1 0 0 1 99.666 75)",
    fill: "#C40C2E",
    stroke: "white",
    strokeWidth: 0.438084
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1122 91.2092L117.737 96.5953",
    stroke: "#C40C2E",
    strokeWidth: 1.75234
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedEmpty);
export default __webpack_public_path__ + "static/media/feed-empty.8543079b135fad7a608fbc409595364e.svg";
export { ForwardRef as ReactComponent };